// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.order-summary-page {
  background: var(--form-bg);
  min-height: 100vh;
  color: var(--form-color);
}
.order-summary-page .summary-header ion-toolbar {
  --background: var(--bg-elevated);
  --color: var(--text-primary-dark);
}
.order-summary-page .summary-header ion-toolbar .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md) var(--page-padding);
  height: var(--header-height);
}
.order-summary-page .summary-header ion-toolbar .header-content .logo {
  font-size: var(--logo-font-size);
  font-weight: var(--font-weight-regular);
  color: var(--logo-color);
}
.order-summary-page .summary-header ion-toolbar .header-content .menu-button {
  background: transparent;
  border: none;
  color: var(--menu-button-color);
  cursor: pointer;
  padding: var(--spacing-sm);
}
.order-summary-page .summary-header ion-toolbar .header-content .menu-button ion-icon {
  font-size: 24px;
}

.summary-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 var(--page-padding) var(--spacing-2xl);
}

.order-section,
.contact-section {
  margin-bottom: var(--spacing-2xl);
}
.order-section .section-header,
.contact-section .section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-lg);
  padding-bottom: var(--spacing-sm);
  border-bottom: 1px solid #E5E5E5;
}
.order-section .section-header .section-title,
.contact-section .section-header .section-title {
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-light);
  margin: 0;
}
.order-section .section-header .edit-btn,
.contact-section .section-header .edit-btn {
  background: none;
  border: none;
  color: var(--button-primary);
  cursor: pointer;
  padding: var(--spacing-xs);
  border-radius: var(--border-radius-sm);
  transition: all 0.2s ease;
}
.order-section .section-header .edit-btn:hover,
.contact-section .section-header .edit-btn:hover {
  background: rgba(74, 144, 226, 0.1);
  transform: scale(1.1);
}
.order-section .section-header .edit-btn ion-icon,
.contact-section .section-header .edit-btn ion-icon {
  font-size: 20px;
}

.order-section .order-items {
  margin-bottom: var(--spacing-lg);
}
.order-section .order-items .order-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid #F0F0F0;
}
.order-section .order-items .order-item:last-child {
  border-bottom: none;
}
.order-section .order-items .order-item .item-name {
  font-size: var(--font-size-body);
  color: var(--text-primary-light);
  flex: 1;
}
.order-section .order-items .order-item .item-price {
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary-light);
}
.order-section .order-total {
  border-top: 1px solid #E5E5E5;
  padding-top: var(--spacing-md);
}
.order-section .order-total .subtotal-row,
.order-section .order-total .final-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-sm);
}
.order-section .order-total .subtotal-row .total-label,
.order-section .order-total .final-total-row .total-label {
  font-size: var(--font-size-body);
  color: var(--text-primary-light);
}
.order-section .order-total .subtotal-row .total-price,
.order-section .order-total .final-total-row .total-price {
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-light);
}
.order-section .order-total .final-total-row {
  border-top: 1px solid #E5E5E5;
  padding-top: var(--spacing-md);
  margin-top: var(--spacing-md);
  margin-bottom: 0;
}
.order-section .order-total .final-total-row .total-label,
.order-section .order-total .final-total-row .total-price {
  font-size: var(--font-size-h3);
  font-weight: var(--font-weight-bold);
}

.contact-section .contact-info .info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid #F0F0F0;
  gap: var(--spacing-md);
}
.contact-section .contact-info .info-row:last-child {
  border-bottom: none;
}
.contact-section .contact-info .info-row .info-label {
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary-light);
  min-width: 140px;
  flex-shrink: 0;
}
.contact-section .contact-info .info-row .info-value {
  font-size: var(--font-size-body);
  color: var(--text-secondary-light);
  text-align: right;
  flex: 1;
  word-break: break-word;
}
@media (max-width: 480px) {
  .contact-section .contact-info .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-xs);
  }
  .contact-section .contact-info .info-row .info-label {
    min-width: unset;
  }
  .contact-section .contact-info .info-row .info-value {
    text-align: left;
  }
}
.contact-section .contact-form .form-group {
  margin-bottom: var(--spacing-lg);
}
.contact-section .contact-form .form-group label {
  display: block;
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary-light);
  margin-bottom: var(--spacing-xs);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.contact-section .contact-form .form-group ion-input,
.contact-section .contact-form .form-group ion-textarea {
  --background: var(--input-bg);
  --color: var(--text-primary-light);
  --border-color: var(--input-border-color);
  --border-radius: var(--input-radius);
  --border-width: 1px;
  --border-style: solid;
  --padding-start: var(--spacing-md);
  --padding-end: var(--spacing-md);
  --padding-top: var(--spacing-sm);
  --padding-bottom: var(--spacing-sm);
}
.contact-section .contact-form .form-group ion-input.error,
.contact-section .contact-form .form-group ion-textarea.error {
  --border-color: var(--error-color);
  --border-width: 2px;
}
.contact-section .contact-form .form-group ion-input:focus-within,
.contact-section .contact-form .form-group ion-textarea:focus-within {
  --border-color: var(--input-focus-color);
  --border-width: 2px;
}
.contact-section .contact-form .form-group .error-message {
  font-size: var(--font-size-small);
  color: var(--error-color);
  margin-top: var(--spacing-xs);
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}
.contact-section .contact-form .form-group .error-message::before {
  content: "⚠";
}
.contact-section .contact-form .form-actions {
  display: flex;
  gap: var(--spacing-md);
  justify-content: flex-end;
  margin-top: var(--spacing-xl);
}
.contact-section .contact-form .form-actions .cancel-btn,
.contact-section .contact-form .form-actions .save-btn {
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--border-radius-md);
  font-size: var(--font-size-button);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}
.contact-section .contact-form .form-actions .cancel-btn {
  background: transparent;
  color: var(--text-secondary-light);
  border: 1px solid #E5E5E5;
}
.contact-section .contact-form .form-actions .cancel-btn:hover {
  background: #F8F9FA;
  border-color: #D6D8DB;
}
.contact-section .contact-form .form-actions .save-btn {
  background: var(--button-primary);
  color: #ffffff;
}
.contact-section .contact-form .form-actions .save-btn:hover {
  background: var(--vendomat-blue-dark);
}

.continue-section {
  margin-top: var(--spacing-2xl);
  padding-top: var(--spacing-xl);
  border-top: 2px solid #E5E5E5;
}
.continue-section .continue-btn {
  width: 100%;
  background: var(--button-primary);
  color: #ffffff;
  padding: var(--spacing-lg);
  border-radius: var(--border-radius-pill);
  font-size: var(--font-size-button-large);
  font-weight: var(--font-weight-medium);
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.continue-section .continue-btn:hover:not(:disabled) {
  background: var(--vendomat-blue-dark);
  transform: translateY(-1px);
  box-shadow: var(--shadow-button-hover);
}
.continue-section .continue-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .summary-container {
    padding: 0 var(--spacing-md) var(--spacing-xl);
  }
  .section-header .section-title {
    font-size: var(--font-size-h3);
  }
  .contact-form .form-actions {
    flex-direction: column;
  }
  .contact-form .form-actions .cancel-btn,
  .contact-form .form-actions .save-btn {
    width: 100%;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .order-item,
  .info-row {
    font-size: var(--font-size-caption);
  }
  .continue-section .continue-btn {
    padding: var(--spacing-md);
    font-size: var(--font-size-button);
  }
}
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.order-section {
  animation: slideInUp 0.4s ease-out;
}

.contact-section {
  animation: slideInUp 0.4s ease-out 0.1s both;
}

.continue-section {
  animation: slideInUp 0.4s ease-out 0.2s both;
}

.contact-form {
  animation: slideInUp 0.3s ease-out;
}

.contact-info {
  animation: slideInUp 0.3s ease-out;
}

ion-input:focus-within,
ion-textarea:focus-within,
.edit-btn:focus,
.continue-btn:focus,
.save-btn:focus,
.cancel-btn:focus {
  outline: 2px solid var(--vendomat-blue-light);
  outline-offset: 2px;
}

@media (prefers-contrast: high) {
  .section-header {
    border-bottom-color: var(--text-primary-light);
    border-bottom-width: 2px;
  }
  .info-row,
  .order-item {
    border-bottom-color: var(--text-secondary-light);
  }
  .order-total .final-total-row {
    border-top-color: var(--text-primary-light);
    border-top-width: 2px;
  }
}
@media print {
  .summary-header,
  .edit-btn,
  .continue-section {
    display: none;
  }
  .order-summary-page {
    background: white;
    color: black;
  }
  .summary-container {
    max-width: none;
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-summary/order-summary.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,0BAAA;EACA,iBAAA;EACA,wBAAA;AADF;AAKI;EACE,gCAAA;EACA,iCAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,8CAAA;EACA,4BAAA;AAHR;AAKQ;EACE,gCAAA;EACA,uCAAA;EACA,wBAAA;AAHV;AAMQ;EACE,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,0BAAA;AAJV;AAMU;EACE,eAAA;AAJZ;;AAYA;EACE,gBAAA;EACA,cAAA;EACA,iDAAA;AATF;;AAaA;;EAEE,iCAAA;AAVF;AAYE;;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,gCAAA;AATJ;AAWI;;EACE,8BAAA;EACA,wCAAA;EACA,gCAAA;EACA,SAAA;AARN;AAWI;;EACE,gBAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,0BAAA;EACA,sCAAA;EACA,yBAAA;AARN;AAUM;;EACE,mCAAA;EACA,qBAAA;AAPR;AAUM;;EACE,eAAA;AAPR;;AAeE;EACE,gCAAA;AAZJ;AAcI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,gCAAA;AAZN;AAcM;EACE,mBAAA;AAZR;AAeM;EACE,gCAAA;EACA,gCAAA;EACA,OAAA;AAbR;AAgBM;EACE,gCAAA;EACA,sCAAA;EACA,gCAAA;AAdR;AAmBE;EACE,6BAAA;EACA,8BAAA;AAjBJ;AAmBI;;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AAjBN;AAmBM;;EACE,gCAAA;EACA,gCAAA;AAhBR;AAmBM;;EACE,gCAAA;EACA,wCAAA;EACA,gCAAA;AAhBR;AAoBI;EACE,6BAAA;EACA,8BAAA;EACA,6BAAA;EACA,gBAAA;AAlBN;AAoBM;;EAEE,8BAAA;EACA,oCAAA;AAlBR;;AA2BI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,4BAAA;EACA,gCAAA;EACA,sBAAA;AAxBN;AA0BM;EACE,mBAAA;AAxBR;AA2BM;EACE,gCAAA;EACA,sCAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;AAzBR;AA4BM;EACE,gCAAA;EACA,kCAAA;EACA,iBAAA;EACA,OAAA;EACA,sBAAA;AA1BR;AA8BM;EA7BF;IA8BI,sBAAA;IACA,uBAAA;IACA,sBAAA;EA3BN;EA6BM;IACE,gBAAA;EA3BR;EA8BM;IACE,gBAAA;EA5BR;AACF;AAmCI;EACE,gCAAA;AAjCN;AAmCM;EACE,cAAA;EACA,mCAAA;EACA,sCAAA;EACA,gCAAA;EACA,gCAAA;EACA,yBAAA;EACA,sBAAA;AAjCR;AAoCM;;EAEE,6BAAA;EACA,kCAAA;EACA,yCAAA;EACA,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,kCAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;AAlCR;AAoCQ;;EACE,kCAAA;EACA,mBAAA;AAjCV;AAoCQ;;EACE,wCAAA;EACA,mBAAA;AAjCV;AAqCM;EACE,iCAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAnCR;AAqCQ;EACE,YAAA;AAnCV;AAwCI;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,6BAAA;AAtCN;AAwCM;;EAEE,4CAAA;EACA,sCAAA;EACA,kCAAA;EACA,sCAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAtCR;AAyCM;EACE,uBAAA;EACA,kCAAA;EACA,yBAAA;AAvCR;AAyCQ;EACE,mBAAA;EACA,qBAAA;AAvCV;AA2CM;EACE,iCAAA;EACA,cAAA;AAzCR;AA2CQ;EACE,qCAAA;AAzCV;;AAiDA;EACE,8BAAA;EACA,8BAAA;EACA,6BAAA;AA9CF;AAgDE;EACE,WAAA;EACA,iCAAA;EACA,cAAA;EACA,0BAAA;EACA,wCAAA;EACA,wCAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AA9CJ;AAgDI;EACE,qCAAA;EACA,2BAAA;EACA,sCAAA;AA9CN;AAiDI;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA/CN;;AAqDA;EACE;IACE,8CAAA;EAlDF;EAqDA;IACE,8BAAA;EAnDF;EAsDA;IACE,sBAAA;EApDF;EAsDE;;IAEE,WAAA;IACA,kBAAA;EApDJ;AACF;AAwDA;EACE;;IAEE,mCAAA;EAtDF;EAyDA;IACE,0BAAA;IACA,kCAAA;EAvDF;AACF;AA2DA;EACE;IACE,UAAA;IACA,2BAAA;EAzDF;EA2DA;IACE,UAAA;IACA,wBAAA;EAzDF;AACF;AA4DA;EACE,kCAAA;AA1DF;;AA6DA;EACE,4CAAA;AA1DF;;AA6DA;EACE,4CAAA;AA1DF;;AA8DA;EACE,kCAAA;AA3DF;;AA8DA;EACE,kCAAA;AA3DF;;AA+DA;;;;;;EAME,6CAAA;EACA,mBAAA;AA5DF;;AAgEA;EACE;IACE,8CAAA;IACA,wBAAA;EA7DF;EAgEA;;IAEE,gDAAA;EA9DF;EAiEA;IACE,2CAAA;IACA,qBAAA;EA/DF;AACF;AAmEA;EACE;;;IAGE,aAAA;EAjEF;EAoEA;IACE,iBAAA;IACA,YAAA;EAlEF;EAqEA;IACE,eAAA;IACA,UAAA;EAnEF;AACF","sourcesContent":["// Order Summary Component Styles\n// Based on \"Deine Bestellung\" design from screenshots\n\n.order-summary-page {\n  background: var(--form-bg);\n  min-height: 100vh;\n  color: var(--form-color);\n\n  // Header styling\n  .summary-header {\n    ion-toolbar {\n      --background: var(--bg-elevated);\n      --color: var(--text-primary-dark);\n\n      .header-content {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: var(--spacing-md) var(--page-padding);\n        height: var(--header-height);\n\n        .logo {\n          font-size: var(--logo-font-size);\n          font-weight: var(--font-weight-regular);\n          color: var(--logo-color);\n        }\n\n        .menu-button {\n          background: transparent;\n          border: none;\n          color: var(--menu-button-color);\n          cursor: pointer;\n          padding: var(--spacing-sm);\n\n          ion-icon {\n            font-size: 24px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.summary-container {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 0 var(--page-padding) var(--spacing-2xl);\n}\n\n// Common section styles\n.order-section,\n.contact-section {\n  margin-bottom: var(--spacing-2xl);\n\n  .section-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: var(--spacing-lg);\n    padding-bottom: var(--spacing-sm);\n    border-bottom: 1px solid #E5E5E5;\n\n    .section-title {\n      font-size: var(--font-size-h2);\n      font-weight: var(--font-weight-semibold);\n      color: var(--text-primary-light);\n      margin: 0;\n    }\n\n    .edit-btn {\n      background: none;\n      border: none;\n      color: var(--button-primary);\n      cursor: pointer;\n      padding: var(--spacing-xs);\n      border-radius: var(--border-radius-sm);\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: rgba(74, 144, 226, 0.1);\n        transform: scale(1.1);\n      }\n\n      ion-icon {\n        font-size: 20px;\n      }\n    }\n  }\n}\n\n// Order Section\n.order-section {\n  .order-items {\n    margin-bottom: var(--spacing-lg);\n\n    .order-item {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: var(--spacing-sm) 0;\n      border-bottom: 1px solid #F0F0F0;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      .item-name {\n        font-size: var(--font-size-body);\n        color: var(--text-primary-light);\n        flex: 1;\n      }\n\n      .item-price {\n        font-size: var(--font-size-body);\n        font-weight: var(--font-weight-medium);\n        color: var(--text-primary-light);\n      }\n    }\n  }\n\n  .order-total {\n    border-top: 1px solid #E5E5E5;\n    padding-top: var(--spacing-md);\n\n    .subtotal-row,\n    .final-total-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: var(--spacing-sm);\n\n      .total-label {\n        font-size: var(--font-size-body);\n        color: var(--text-primary-light);\n      }\n\n      .total-price {\n        font-size: var(--font-size-body);\n        font-weight: var(--font-weight-semibold);\n        color: var(--text-primary-light);\n      }\n    }\n\n    .final-total-row {\n      border-top: 1px solid #E5E5E5;\n      padding-top: var(--spacing-md);\n      margin-top: var(--spacing-md);\n      margin-bottom: 0;\n\n      .total-label,\n      .total-price {\n        font-size: var(--font-size-h3);\n        font-weight: var(--font-weight-bold);\n      }\n    }\n  }\n}\n\n// Contact Section\n.contact-section {\n  .contact-info {\n    .info-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      padding: var(--spacing-sm) 0;\n      border-bottom: 1px solid #F0F0F0;\n      gap: var(--spacing-md);\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      .info-label {\n        font-size: var(--font-size-body);\n        font-weight: var(--font-weight-medium);\n        color: var(--text-primary-light);\n        min-width: 140px;\n        flex-shrink: 0;\n      }\n\n      .info-value {\n        font-size: var(--font-size-body);\n        color: var(--text-secondary-light);\n        text-align: right;\n        flex: 1;\n        word-break: break-word;\n      }\n\n      // Responsive layout for mobile\n      @media (max-width: 480px) {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: var(--spacing-xs);\n\n        .info-label {\n          min-width: unset;\n        }\n\n        .info-value {\n          text-align: left;\n        }\n      }\n    }\n  }\n\n  // Contact form styles\n  .contact-form {\n    .form-group {\n      margin-bottom: var(--spacing-lg);\n\n      label {\n        display: block;\n        font-size: var(--font-size-caption);\n        font-weight: var(--font-weight-medium);\n        color: var(--text-primary-light);\n        margin-bottom: var(--spacing-xs);\n        text-transform: uppercase;\n        letter-spacing: 0.05em;\n      }\n\n      ion-input,\n      ion-textarea {\n        --background: var(--input-bg);\n        --color: var(--text-primary-light);\n        --border-color: var(--input-border-color);\n        --border-radius: var(--input-radius);\n        --border-width: 1px;\n        --border-style: solid;\n        --padding-start: var(--spacing-md);\n        --padding-end: var(--spacing-md);\n        --padding-top: var(--spacing-sm);\n        --padding-bottom: var(--spacing-sm);\n\n        &.error {\n          --border-color: var(--error-color);\n          --border-width: 2px;\n        }\n\n        &:focus-within {\n          --border-color: var(--input-focus-color);\n          --border-width: 2px;\n        }\n      }\n\n      .error-message {\n        font-size: var(--font-size-small);\n        color: var(--error-color);\n        margin-top: var(--spacing-xs);\n        display: flex;\n        align-items: center;\n        gap: var(--spacing-xs);\n\n        &::before {\n          content: '⚠';\n        }\n      }\n    }\n\n    .form-actions {\n      display: flex;\n      gap: var(--spacing-md);\n      justify-content: flex-end;\n      margin-top: var(--spacing-xl);\n\n      .cancel-btn,\n      .save-btn {\n        padding: var(--spacing-sm) var(--spacing-lg);\n        border-radius: var(--border-radius-md);\n        font-size: var(--font-size-button);\n        font-weight: var(--font-weight-medium);\n        cursor: pointer;\n        transition: all 0.2s ease;\n        border: none;\n      }\n\n      .cancel-btn {\n        background: transparent;\n        color: var(--text-secondary-light);\n        border: 1px solid #E5E5E5;\n\n        &:hover {\n          background: #F8F9FA;\n          border-color: #D6D8DB;\n        }\n      }\n\n      .save-btn {\n        background: var(--button-primary);\n        color: #ffffff;\n\n        &:hover {\n          background: var(--vendomat-blue-dark);\n        }\n      }\n    }\n  }\n}\n\n// Continue Section\n.continue-section {\n  margin-top: var(--spacing-2xl);\n  padding-top: var(--spacing-xl);\n  border-top: 2px solid #E5E5E5;\n\n  .continue-btn {\n    width: 100%;\n    background: var(--button-primary);\n    color: #ffffff;\n    padding: var(--spacing-lg);\n    border-radius: var(--border-radius-pill);\n    font-size: var(--font-size-button-large);\n    font-weight: var(--font-weight-medium);\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n\n    &:hover:not(:disabled) {\n      background: var(--vendomat-blue-dark);\n      transform: translateY(-1px);\n      box-shadow: var(--shadow-button-hover);\n    }\n\n    &:disabled {\n      background: #cccccc;\n      cursor: not-allowed;\n      transform: none;\n      box-shadow: none;\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .summary-container {\n    padding: 0 var(--spacing-md) var(--spacing-xl);\n  }\n\n  .section-header .section-title {\n    font-size: var(--font-size-h3);\n  }\n\n  .contact-form .form-actions {\n    flex-direction: column;\n\n    .cancel-btn,\n    .save-btn {\n      width: 100%;\n      text-align: center;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .order-item,\n  .info-row {\n    font-size: var(--font-size-caption);\n  }\n\n  .continue-section .continue-btn {\n    padding: var(--spacing-md);\n    font-size: var(--font-size-button);\n  }\n}\n\n// Animation for smooth transitions\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.order-section {\n  animation: slideInUp 0.4s ease-out;\n}\n\n.contact-section {\n  animation: slideInUp 0.4s ease-out 0.1s both;\n}\n\n.continue-section {\n  animation: slideInUp 0.4s ease-out 0.2s both;\n}\n\n// Form transition animations\n.contact-form {\n  animation: slideInUp 0.3s ease-out;\n}\n\n.contact-info {\n  animation: slideInUp 0.3s ease-out;\n}\n\n// Focus management for accessibility\nion-input:focus-within,\nion-textarea:focus-within,\n.edit-btn:focus,\n.continue-btn:focus,\n.save-btn:focus,\n.cancel-btn:focus {\n  outline: 2px solid var(--vendomat-blue-light);\n  outline-offset: 2px;\n}\n\n// High contrast mode support\n@media (prefers-contrast: high) {\n  .section-header {\n    border-bottom-color: var(--text-primary-light);\n    border-bottom-width: 2px;\n  }\n\n  .info-row,\n  .order-item {\n    border-bottom-color: var(--text-secondary-light);\n  }\n\n  .order-total .final-total-row {\n    border-top-color: var(--text-primary-light);\n    border-top-width: 2px;\n  }\n}\n\n// Print styles\n@media print {\n  .summary-header,\n  .edit-btn,\n  .continue-section {\n    display: none;\n  }\n\n  .order-summary-page {\n    background: white;\n    color: black;\n  }\n\n  .summary-container {\n    max-width: none;\n    padding: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
